import {Tabs as TabsPrimitive} from "@base-ui/react/tabs";
import {clsx} from "clsx";
import styles from "./Tabs.module.css";


function TabsRoot(props: TabsPrimitive.Root.Props) {
	return <TabsPrimitive.Root data-slot="tabs" {...props} />;
}

function TabsList({className, ...props}: TabsPrimitive.List.Props) {
	return (
		<TabsPrimitive.List
			data-slot="tabs-list"
			className={clsx(styles.list, className)}
			{...props}
		/>
	);
}

function TabsTab({className, invalid, ...props}: TabsPrimitive.Tab.Props & {
	invalid?: boolean
}) {
	return (
		<TabsPrimitive.Tab
			data-slot="tabs-tab"
			data-invalid={invalid ? "" : undefined}
			className={clsx(styles.tab, className)}
			{...props}
		/>
	);
}

function TabsPanel({className, ...props}: TabsPrimitive.Panel.Props) {
	return (
		<TabsPrimitive.Panel
			data-slot="tabs-panel"
			className={clsx(styles.panel, className)}
			{...props}
		/>
	);
}

const Tabs = {
	Root: TabsRoot,
	List: TabsList,
	Tab: TabsTab,
	Panel: TabsPanel,
};

export {Tabs};
